export default function initCloneTableHeader() {
	document.querySelectorAll('.offers-section').forEach((holder) => {
		const mobileTargetBox = holder.querySelector('.section-top');
		const origTable = holder.querySelector('.offers-table-wrap');
		const origTH = origTable.querySelectorAll('th');
		let mobileHead = null;
		let desktopHead = null;
		let clonedTHead = null;
		let timer = null;

		if (!origTable || !origTH) return;

		cloneTHead();
		setColWidth();

		origTable.classList.add('main-table');

		function cloneTHead() {
			clonedTHead = origTable.cloneNode(true);

			const tbody = clonedTHead.querySelector('tbody');

			if (tbody) {
				tbody.parentNode.removeChild(tbody);
			}

			desktopHead = clonedTHead.cloneNode(true);
			mobileHead = clonedTHead.cloneNode(true);

			origTable.prepend(desktopHead);

			if (mobileTargetBox) {
				mobileTargetBox.appendChild(mobileHead);
			}
		}

		function setColWidth() {
			const desktopHeadTH = desktopHead.querySelectorAll('th');
			const mobileHeadTH = mobileHead.querySelectorAll('th');

			origTH.forEach((origIt, i) => {
				if (desktopHeadTH.length) {
					desktopHeadTH[i].style.width = origIt.offsetWidth + 'px';
				}

				if (mobileHeadTH.length) {
					mobileHeadTH[i].style.width = origIt.offsetWidth + 'px';
				}
			});
		}

		['resize', 'orientationchange'].forEach((handler) => {
			window.addEventListener(handler, () => {
				clearTimeout(timer);

				timer = setTimeout(setColWidth, 150);
			});
		});
	});
}